import { render } from "./ProveedoresPage.vue?vue&type=template&id=1766fc56"
import script from "./ProveedoresPage.vue?vue&type=script&lang=js"
export * from "./ProveedoresPage.vue?vue&type=script&lang=js"

import "./ProveedoresPage.vue?vue&type=style&index=0&id=1766fc56&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__